import styled from 'styled-components';

export const Container = styled.section`
  background-color: #fff;
  padding-bottom: 100px;
`;

export const Title = styled.div`
  text-transform: uppercase;
  font-size: 2em;
  padding: 50px 0 75px;
  text-align: center;
  font-family: 'GT America';
`;
